import { WorkerCardErrorInfo } from 'types';

export type { WorkerCard } from 'graphql/server/queries/types';
export type { WorkerCardAlreadyExistsErrorExtensions } from 'types';

export enum BadgeType {
  QrCode,
  NewBadge,
  NewIDCard,
  ExistingBadge,
  TempBadge,
  MobileBadge,
  FacialRecognition,
}

export type ReassignBadgeState = {
  reassignBadge: () => Promise<void>;
  workerCardInfo: WorkerCardErrorInfo[];
};
